var map = {
	"./academic-advisers.svg": 76050,
	"./academic-levels.svg": 98462,
	"./acccomodation.svg": 67519,
	"./acceptance-deadlines.svg": 65950,
	"./accepted.svg": 47304,
	"./activate-student-acc.svg": 65898,
	"./admin.svg": 46236,
	"./admission-rounds.svg": 97772,
	"./admission-status.svg": 65497,
	"./admission-upload.svg": 72352,
	"./advertised-programmes.svg": 75938,
	"./affiliations.svg": 8802,
	"./ahea-sm.svg": 11771,
	"./all-candidates.svg": 30511,
	"./annoucement.svg": 62624,
	"./announcement-v2.svg": 38323,
	"./announcement.svg": 4478,
	"./appraisal_home.svg": 67126,
	"./archive.svg": 72087,
	"./assessment.svg": 31333,
	"./assessment_score.svg": 62086,
	"./assessment_scoring_policy.svg": 94712,
	"./assignments.svg": 46923,
	"./available-bed.svg": 77866,
	"./avatar.svg": 97420,
	"./awaiting.svg": 71785,
	"./ballot-box.svg": 21929,
	"./bank account.svg": 72692,
	"./bed-space-hostel.svg": 62459,
	"./bed.svg": 84612,
	"./calendar-module.svg": 92694,
	"./campuses.svg": 69564,
	"./career-ladder.svg": 90366,
	"./cbt.svg": 59012,
	"./centres-and-directorates.svg": 56057,
	"./charges.svg": 87178,
	"./clearance-docs.svg": 39749,
	"./cleared.svg": 24313,
	"./close.svg": 15321,
	"./collaborate.svg": 21685,
	"./collaboration-projects.svg": 58401,
	"./colleges.svg": 68569,
	"./copy.svg": 61420,
	"./course-allocation.svg": 58819,
	"./course-duration.svg": 67089,
	"./course-management.svg": 91228,
	"./course-reg.svg": 18521,
	"./course-registration.svg": 92254,
	"./courses.svg": 47635,
	"./curriculum.svg": 30702,
	"./dashboard-65.svg": 81761,
	"./dashboard.svg": 61329,
	"./declined.svg": 78093,
	"./degree.svg": 9515,
	"./delete.svg": 32414,
	"./department-v2.svg": 55906,
	"./department.svg": 57533,
	"./download.svg": 87867,
	"./elections.svg": 67457,
	"./escalate.svg": 95947,
	"./exam-body.svg": 17247,
	"./examination-office.svg": 66591,
	"./faculty.svg": 97221,
	"./feeds-module.svg": 40455,
	"./fees.svg": 52664,
	"./finance.svg": 40463,
	"./grade_profile_allocation.svg": 68955,
	"./grades.svg": 77831,
	"./grading_profile.svg": 25087,
	"./graduate.svg": 30148,
	"./graduate_list.svg": 23271,
	"./graduation-requirement.svg": 20725,
	"./hostel-allocated.svg": 23146,
	"./hostel-block.svg": 78730,
	"./hostel-booking.svg": 56412,
	"./hostel-room.svg": 8834,
	"./hostel.svg": 74346,
	"./hostel_blocks.svg": 28983,
	"./hostel_blocks_allocation.svg": 55212,
	"./incoming-student.svg": 31293,
	"./inspired-logo.svg": 43407,
	"./interests.svg": 85944,
	"./invoice.svg": 37832,
	"./invoices.svg": 48123,
	"./learning-management.svg": 86955,
	"./lecturer-v2.svg": 22012,
	"./lecturer.svg": 58763,
	"./lecturers.svg": 5410,
	"./lectures.svg": 53498,
	"./levels.svg": 65390,
	"./lms.svg": 86665,
	"./lms_home.svg": 31913,
	"./messages.svg": 39847,
	"./modes-of-entry.svg": 334,
	"./more-info.svg": 25385,
	"./my-application.svg": 272,
	"./not-cleared.svg": 9129,
	"./offered.svg": 10284,
	"./open.svg": 74539,
	"./payment-method.svg": 94767,
	"./payment.svg": 97395,
	"./pending-clearance.svg": 86717,
	"./printouts.svg": 89871,
	"./programmes.svg": 72582,
	"./progress.svg": 41370,
	"./progression.svg": 80096,
	"./projects.svg": 88237,
	"./rank.svg": 5725,
	"./rejected.svg": 44269,
	"./reserved-bed.svg": 52317,
	"./resolved.svg": 65415,
	"./results.svg": 92951,
	"./rooms_and_bed_spaces.svg": 63931,
	"./rooms_and_bed_spaces_allocation.svg": 96192,
	"./schedule.svg": 34772,
	"./scholar-hostel.svg": 64581,
	"./screening.svg": 84933,
	"./semester.svg": 39093,
	"./service-units.svg": 14506,
	"./shopping-cart.svg": 78530,
	"./signature.svg": 33823,
	"./specialization.svg": 7392,
	"./staff.svg": 78851,
	"./status.svg": 24837,
	"./student-v2.svg": 7705,
	"./students.svg": 48859,
	"./sub-admin.svg": 56597,
	"./tick-22.svg": 8113,
	"./ticket-outline.svg": 94482,
	"./timetable-v2.svg": 50833,
	"./timetable.svg": 88160,
	"./total.svg": 85167,
	"./transactions.svg": 85592,
	"./transfer-request.svg": 33226,
	"./transfer-requests.svg": 71381,
	"./transfer.svg": 34138,
	"./user-roles-and -permissions.svg": 72709,
	"./users-v2.svg": 60790,
	"./users.svg": 19337,
	"./validate.svg": 64273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5312;